import { render, staticRenderFns } from "./CategoryCardProfitabilityFooter.vue?vue&type=template&id=5d4af618&scoped=true&"
import script from "./CategoryCardProfitabilityFooter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CategoryCardProfitabilityFooter.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CategoryCardProfitabilityFooter.vue?vue&type=style&index=0&id=5d4af618&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4af618",
  null
  
)

export default component.exports